import Modal from "../../../lib/ModalWindow/Modal";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import styles from "./BrandOfTheMonthModal.module.scss";
import window from "../../../lib/WindowExtended";
import "./BrandOfTheMonthModal_generalClasses.scss";
import NewsletterForm from "./NewsletterForm/NewsletterForm";
import LoginForm from "./LoginForm/LoginForm";
import MagicLinkForm from "./MagicLinkForm/MagicLinkForm";
import Accordion from "../../../lib/Accordion/Accordion";
import AccordionItem from "../../../lib/Accordion/AccordionItem/AccordionItem";
import {useCustomerSelector} from "../../../../store";

const BrandOfTheMonthModal: React.FC = () => {
  const homepageRedirect = window.location.origin;
  const {customer} = useCustomerSelector();
  const {t} = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isConfirmationModalVisible, setIsConfirmationModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loggedInSuccessful, setLoggedInSuccessful] = useState(false);
  const [magicEmailSent, setMagicEmailSent] = useState("");

  useEffect(() => {
    if (!customer || !customer.isRecognised || (customer.isRecognised && !customer.newsletterFlag)) {
      setIsModalVisible(true);
    }
  }, [customer.isLoggedIn]);

  const onCloseModal = () => {
    location.replace(homepageRedirect);
  };

  const onCustomerLoggedIn = (success: boolean) => {
    if (!success) {
      setErrorMessage("Nutzername / E-Mail-Adresse oder Passwort unbekannt.");

      return;
    }
    if (customer.newsletterFlag) {
      setIsModalVisible(false);
    } else {
      setLoggedInSuccessful(true);
      setErrorMessage(
        "Leider sind Sie noch kein Newsletterabonennt:in. Bitte registrieren Sie sich vorab, um die Vorteile des Newsletters genießen zu können.",
      );
    }
  };

  const EmailSent: React.FC = () => (
    <React.Fragment>
      <h2>{t("form.checkInbox")}</h2>
      <p className="content">
        {t("general.emailWithLoginLink--email", {
          email: magicEmailSent,
        })}
      </p>
    </React.Fragment>
  );

  if (magicEmailSent) {
    return (
      <Modal isVisible={isModalVisible} closeFunction={onCloseModal}>
        <EmailSent />
      </Modal>
    );
  }

  return (
    <>
      <Modal isVisible={isConfirmationModalVisible} closeFunction={onCloseModal}>
        <h2>Vielen Dank für Ihre Anmeldung</h2>
        <p>
          Fast geschafft: Um alle Aktionen unserer Marke des Monats zu sehen, bestätigen Sie bitte Ihre Mail-Adresse.
          Klicken Sie dafür in der Bestätigungsmail, die wir Ihnen an Ihre Mail-Adresse geschickt haben, auf „Jetzt
          Newsletter-Registrierung bestätigen.“
        </p>
        <p>
          Im Anschluss werden Sie automatisch auf unsere allgemeine Newsletter-Seite weitergeleitet. Von dieser gelangen
          Sie ganz einfach zu allen Aktionen unserer Marke des Monats.
        </p>
      </Modal>
      <Modal isVisible={isModalVisible} closeFunction={onCloseModal}>
        <div id="BrandOfTheMonthModal">
          <div id="brandOfTheMonthModalNewsletter" className="bomNewsletter">
            <h2 className="bomNewsletter__title">{t("newsletter.brandOfTheMonth")}</h2>
            <p className="bomNewsletter__text">{t("newsletter.subscribeForNewsAndOffers")}</p>
            <NewsletterForm
              onSuccess={() => {
                setIsConfirmationModalVisible(true);
                setIsModalVisible(false);
              }}
            />
          </div>
          <div className={styles.orSeparator}>
            <span>{t("general.or")}</span>
          </div>
          <Accordion>
            <AccordionItem title={t("customer.loginWithPassword")}>
              {loggedInSuccessful && (
                <span className={styles.successMessage}>
                  <span className={"icon icon-check--green"} />
                  {"Sie sind eingeloggt"}
                </span>
              )}
              {errorMessage && <span className={styles.errorMessage}>{errorMessage}</span>}
              {!loggedInSuccessful && <LoginForm onLoggedIn={onCustomerLoggedIn} />}
            </AccordionItem>
            <AccordionItem title={t("customer.loginWithEmailOnly")}>
              <MagicLinkForm
                onEmailSent={(email) => {
                  setMagicEmailSent(email);
                }}
              />
            </AccordionItem>
          </Accordion>
        </div>
      </Modal>
    </>
  );
};

export default BrandOfTheMonthModal;
